// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"3c8248d9","647":"f56e324e"}[chunkId] + ".chunk.js";
};